export default "__VITE_ASSET__15320ae5__"